/**
 * `54` — *When {column, columnId} changes*, any column type. With the `$any$` wildcard it fires
 * for **every** column on the board, which is how static recipe `127` ("when any column
 * changes") is represented.
 *
 * The three backfill fields (`runBackfill`, `shouldApplyOnExistingItems`, `maxItemsToApply`) are
 * the "apply to existing items" one-shot; the engine reads them in `automations.runNow`, not
 * here, so the trigger stays a pure predicate.
 */
import { z } from 'zod';
import { defineTrigger } from '../block.js';
import { ANY_VALUE, booleanish, columnRefSchema, integerish } from '../values.js';
export const columnChangesParams = z.object({
    columnId: z.union([z.literal(ANY_VALUE), columnRefSchema]),
    /*
     * P-290: monday's builder stores both of these as the selected option of a `list` control —
     * `{value: true}` on automation 371023875 — so they are `booleanish`, not `z.boolean()`.
     */
    runBackfill: booleanish.optional(),
    shouldApplyOnExistingItems: booleanish.optional(),
    maxItemsToApply: integerish.optional(),
});
export const columnChangesTrigger = defineTrigger({
    id: '54',
    kind: 'trigger',
    app: 'monday',
    sentencePartial: 'When {column, columnId} changes',
    paramsSchema: columnChangesParams,
    subscribes: ['cell.changed'],
    references: (params) => params.columnId === ANY_VALUE
        ? []
        : [{ kind: 'column', id: params.columnId.columnId, invalid: params.columnId.invalid }],
    matches(event, params) {
        if (params.columnId === ANY_VALUE)
            return true;
        return event.payload.columnId === params.columnId.columnId;
    },
    outputs(event) {
        return {
            itemId: event.itemId,
            boardId: event.boardId,
            columnId: event.payload.columnId,
            columnValue: event.payload.value,
            prevValue: event.payload.previousValue,
        };
    },
});
//# sourceMappingURL=54.js.map